import ShippingInfo from "@/app/shared/logistics/tracking/shipping-info";
import TrackingHistory from "@/app/shared/logistics/tracking/tracking-history";
import TrackingOverview from "@/app/shared/logistics/tracking/tracking-overview";
import PageHeader from "@/app/shared/page-header";
import routes from "@/routers/routes";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

export default function TrackingPage() {
    const { id } = useParams();
    const pageHeader = useMemo(() => {
        return {
            title: "Tracking",
            breadcrumb: [
                {
                    name: "Logistics",
                },
                {
                    href: routes.logistics.dashboard,
                    name: "Tracking",
                },
                {
                    name: id ?? "",
                },
            ],
        };
    }, [id]);

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            />
            <TrackingOverview className="mb-10" />
            <ShippingInfo />
            <TrackingHistory />
        </>
    );
}
